export default __webpack_public_path__ + "static/media/cashless-dental.7b20b0c0.svg";